module.exports = __webpack_public_path__ + "img/history-2016.48a65d96.webp";